import React from 'react';
import { CheckIcon } from 'lucide-react';
import { summaryRows } from '../data/summary';
import { price, productShortName, totalBonuses, totalVolumes } from '../data/offer';
export function SummaryTable() {
  return <section className="bg-stage-deep tech-grid py-16 sm:py-20" aria-labelledby="summary-title" data-id="element-220" data-mp="o71jkm7hsj9a">
      <div className="mx-auto max-w-4xl px-4" data-id="element-221" data-mp="j8880zbrn2br">
        <h2 id="summary-title" className="text-center text-3xl font-extrabold text-white sm:text-4xl" data-id="element-222" data-mp="j5c9b8s3g9m9">
          Everything included
        </h2>
        <p className="mt-3 text-center text-silver" data-id="element-223" data-mp="1bwvx75zmybul">
          {productShortName} · {totalVolumes} volumes + {totalBonuses} bonuses ·{' '}
          <b className="text-silverBright" data-id="element-224" data-mp="16yuc6fing2gh">{price}</b>
        </p>

        <ul className="mt-10 grid gap-3 sm:grid-cols-2" data-id="element-225" data-mp="12ue6ofcy6x1s">
          {summaryRows.map(([feature, detail]) => <li key={feature} className="flex gap-3 rounded-lg border border-silverEdge bg-navy p-4" data-id="element-226" data-mp="3rojpup7m9i7l">
              <span className="metal-surface mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full" data-id="element-227" data-mp="3nk3lisdniiuh">
                <CheckIcon className="h-3.5 w-3.5 text-navyDeep" aria-hidden="true" data-id="element-228" data-mp="3iatk9wng7ja5" />
              </span>
              <p data-id="element-229" data-mp="3n9mv1hbcow6m">
                <b className="block text-sm text-silverBright" data-id="element-230" data-mp="39chrbnz409ej">{feature}</b>
                <span className="text-sm text-silver" data-id="element-231" data-mp="39ekg64oizwho">{detail}</span>
              </p>
            </li>)}
        </ul>

        <blockquote className="mx-auto mt-10 max-w-2xl rounded-xl border-l-4 border-silver bg-navy px-6 py-5 text-center text-lg font-bold leading-relaxed text-silverBright" data-id="element-232" data-mp="2zlwm3hoxk6mn">
          “The best time to have these materials was at the start of your year. The second-best time is today.”
        </blockquote>
      </div>
    </section>;
}